export const mainButtonStyle = {
  width: "10rem",
  borderRadius: "1.25rem",
  fontFamily: "Arial",
};
